<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
export default {
  name: 'CellRendererActions',
  computed: {
    userLogin(){
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    editRecord () {
      //this.$router.push(`/management/user/form/${this.params.data.code}`).catch(() => {})
      this.$store.commit('userManagement/SET_SELECTED', {
        six:'',
        five:'',
        five2:'',
        four:'',
        three:'',
        twotop:'',
        twobottom:'',
        datetime:'',
        datetime2:'',
        three2:'',
        two:'',
        two2:'',
        key:'',
      });
      this.$store.commit('userManagement/SET_SELECTED', this.params.data);
      this.$store.commit('userManagement/SET_POPUP', true);
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.datetime}"`,
        accept: this.deleteRecord,
        acceptText: 'Delet'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      firebase.database().ref().child(`huay/${this.params.data.web}/${this.params.data.key}`).remove().then(() =>{
        this.showDeleteSuccess()
        if(this.params.data.web === 1)
          this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
        else if(this.params.data.web === 2)
          this.$store.dispatch('userManagement/fetchUsers2').catch(err => { console.error(err) })
        else if(this.params.data.web === 14)
          this.$store.dispatch('userManagement/fetchUsers14').catch(err => { console.error(err) })
        else if(this.params.data.web === 15)
          this.$store.dispatch('userManagement/fetchUsers15').catch(err => { console.error(err) })
        else if(this.params.data.web >= 7)
          this.$store.dispatch('userManagement/fetchUsersHuay',Number(this.params.data.web)).catch(err => { console.error(err) })
        else
          this.$store.dispatch('userManagement/fetchUsers'+this.params.data.web).catch(err => { console.error(err) })
      });
      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Lotto Deleted',
        text: 'The selected lotto was successfully deleted'
      })
    }
  }
}
</script>
